module.exports = __webpack_public_path__ + "img/news02-M02.7bf7fda1.png";